import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Component({
  selector: 'app-review-timeoff-request-modal',
  templateUrl: './review-timeoff-request-modal.component.html',
  styleUrls: ['./review-timeoff-request-modal.component.css']
})
export class ReviewTimeoffRequestModalComponent implements OnInit {
  @Input() dates: any;
  @Input() stdWorkdayHours: any;
  @Input() defaultFridayHours: any;
  requests: any[] = [];
  @Input() newBalance: any;
  @Input() total: any;
  @Input() requestType: any;
  @Input() leaveCodeID: any;
  @Input() hours: any;
  @Input() leaveCodeDesc: string;
  @Input() customFridayMode: any;
  @Input() projectedInitial: any;
  @Input() Languages: any;
  @Input() settings: any;
  @Input() format: string;
  @Input() hideInitRemainHourModal: boolean;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.groupDates();
  }


  groupDates() {
    var temp = [];
    temp.push(this.dates[0].date);
    for (let i = 0; i < this.dates.length - 1; i++) {
      //check if next date is continuous with previous date
      var currentDay = new Date(this.dates[i].date);
      var nextDay = new Date(this.dates[i + 1].date);
      var tomorrow = new Date(this.dates[i].date);
      tomorrow.setDate(tomorrow.getDate() + 1);
      var threeDays = new Date(this.dates[i].date);
      threeDays.setDate(threeDays.getDate() + 3);
      if (tomorrow.getTime() == nextDay.getTime()) {
        temp.push(this.dates[i + 1].date);
      }
      //special case: check for Friday - Monday
      else if (currentDay.getDay() == 5 && nextDay.getDay() == 1) {
        if (threeDays.getTime() == nextDay.getTime())
          temp.push(this.dates[i + 1].date);
        else {
          this.addToRequests(temp);
          temp = [];
          temp.push(this.dates[i + 1].date);
        }
      }
      //if next date is not continuous, push current list to request list
      else {
        this.addToRequests(temp);
        temp = [];
        temp.push(this.dates[i + 1].date);
      }

    }
    this.addToRequests(temp);
  }

  addToRequests(temp) {
    var requestString, dateString;
    if (temp.length > 1) {
      requestString = this.leaveCodeDesc + " - Multiday";
      dateString = moment(temp[0]).format(this.format) + " - " + moment(temp[temp.length - 1]).format(this.format);
    }
    else {
      requestString = this.leaveCodeDesc + " - Single Day";
      dateString = moment(temp[0]).format(this.format);
    }
    var hours = this.calculateHours(temp);
    this.requests.push({ DateString: dateString, RequestString: requestString, Hours: hours });
  }

  calculateHours(temp) {
    var total = 0;
    temp.forEach(val => {
      //If request is a partial requests, use provided hours
      if (this.requestType == 'P') {
        total += this.hours;
      }
      else if (this.customFridayMode && (new Date(val).getDay()) == 5) {
        //TODO get value
        total += this.defaultFridayHours;
      }
      else {
        total += this.hours;
      }
    });
    return total;
  }

  cancelClicked() {
    this.activeModal.close('cancel');
  }

  submitClicked() {
    this.openModal();
    this.activeModal.close('submit');
  }

  openModal() {
    document.getElementById('modal').style.display = 'block';
    document.getElementById('fade').style.display = 'block';
  }
}
